import React, { Component } from "react";
import Chart from "react-apexcharts";

class App7 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        
          series: [{
            name: "STOCK ABC",
            data: ['1000' , '2000' , '3000' , '2000' , '5000' ]
          }],
          options: {
            chart: {
              type: 'area',
              height: 350,
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            
            title: {
              text: 'Area Chart',
              align: 'left'
            },
            subtitle: {
              text: 'Price Movements',
              align: 'left'
            },
            labels: ['12JAN' , '15JAN' , '20JAN' , '25JAN' ,'30JAN'],
            xaxis: {
              type: 'datetime',
            },
            yaxis: {
              opposite: true
            },
            legend: {
              horizontalAlign: 'left'
            }
          },
        
        
        };
      }

  

    render() {
      return (
        

  <div id="chart">
<Chart options={this.state.options} series={this.state.series} type="area" height={350} />
</div>


      );
    }
  }

export default App7;